// Subscription / Stripe pricing has no equivalent in the super-admin spec.
// The legacy /api/subscription/* endpoints were tenant-billing, not super-admin.
// All exports below are no-op stubs that throw at call-time so the build stays green
// while the UI surface is hidden — see api/_legacy.js.

import { removedStub } from 'api/_legacy';

export const getPricingData = removedStub('getPricingData');
export const getSubscriptionData = removedStub('getSubscriptionData');
export const createSubscription = removedStub('createSubscription');
export const updateSubscription = removedStub('updateSubscription');
export const deleteSubscription = removedStub('deleteSubscription');
export const getAllPricings = removedStub('getAllPricings');
export const getSubscriptionTypeData = removedStub('getSubscriptionTypeData');
export const createSubscriptionType = removedStub('createSubscriptionType');
export const updateSubscriptionType = removedStub('updateSubscriptionType');
export const deleteSubscriptionType = removedStub('deleteSubscriptionType');
export const getAllSubscriptions = removedStub('getAllSubscriptions');
export const getAllSubscriptionPlans = removedStub('getAllSubscriptionPlans');
